import React from 'react';

import ArtifactForm, {
  ArtifactFormComponentProps,
} from '@/features/artifacts/components/ArtifactForm';
import {
  ArtifactFormOverrides,
  ArtifactWidgetProps,
} from '@/features/artifacts/components/ArtifactForm/ArtifactForm.types';
import { useArtifactFormConfig } from '@/features/artifacts/hooks/useArtifactFormConfig';
import { AgendamentoSelectDateWidget } from '@/features/artifacts/forms/Agendamento.widgets';

import { appointmentDateOptions } from '../../helpers';

const AgendamentoFormDefault: ArtifactFormOverrides = [
  {
    name: 'reasonCode',
    label: 'Motivo',
    attrs: { autoFocus: true },
    containerStyle: { flex: '0 1 100%' },
  },
  {
    name: 'startDate',
    label: 'Data',
  },
  { name: 'startTime', label: 'Horário' },
  {
    name: 'description',
    label: 'Observação',
    containerStyle: { flex: '0 1 100%' },
  },
];

export type FormAgendamentoProps = ArtifactFormComponentProps;

const FormAgendamento: React.FC<FormAgendamentoProps> = ({
  resource,
  onSubmit,
  onCancel,
  disabled = false,
  loading = false,
  readOnly = false,
}) => {
  const baseForm = useArtifactFormConfig('agendamento', AgendamentoFormDefault);

  const form = React.useMemo(() => {
    const appointment = resource as fhir4.Appointment;
    const options = appointmentDateOptions(appointment);

    if (options.length > 1) {
      // Create custom override for startDate field with InputFieldSelect
      return baseForm.map(field => {
        if (field.name === 'startDate') {
          return {
            ...field,
            widget: (widgetProps: ArtifactWidgetProps) => (
              // eslint-disable-next-line react/jsx-props-no-spreading
              <AgendamentoSelectDateWidget {...widgetProps} options={options} />
            ),
          };
        }
        return field;
      });
    }

    return baseForm;
  }, [resource, baseForm]);

  return (
    <ArtifactForm
      form={form}
      resource={resource}
      loading={loading}
      disabled={disabled}
      readOnly={readOnly}
      onResourceSubmit={onSubmit}
      onResourceSubmitCancel={onCancel}
    />
  );
};

export default FormAgendamento;
